<template>
	<div class="hstack gap-2 justify-content-center">
		<div>Powered by</div>
		<img src="@/assets/img/logo/main.png" alt="Logo" class="logo-big-white h-rem-4" />
	</div>
</template>